/** Nom de copie unique : « Base (2) », « Base (3) »… (insensible à la casse). */
export function uniqueCopyName(base: string, existing: string[]): string {
  let n = 2;
  let candidate = `${base} (${n})`;
  while (existing.some(e => e.toLowerCase() === candidate.toLowerCase())) {
    n++;
    candidate = `${base} (${n})`;
  }
  return candidate;
}
